 import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IPreControlTreatmentDatatableFilterFormMeta {
  bank: FormInputMeta,
  transactionCode: FormInputMeta,
  acquirerReferenceNumber: FormInputMeta,
  cardHolderNumber: FormInputMeta,
  processingStartDate: FormInputMeta,
  processingEndDate: FormInputMeta,
  reasonCode: FormInputMeta,
  // Schema
  schema: any,
}

const PreControlTreatmentDatatableFilterFormMeta = {} as IPreControlTreatmentDatatableFilterFormMeta;


PreControlTreatmentDatatableFilterFormMeta.bank = commonFormMeta.bank;

PreControlTreatmentDatatableFilterFormMeta.transactionCode = {
  name: 'transactionCode',
  type: 'select',
  label: 'Code transaction',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
PreControlTreatmentDatatableFilterFormMeta.acquirerReferenceNumber = {
  name: "acquirerReferenceNumber",
  type: "number",
  label: "Numero de reference acquéreur",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
PreControlTreatmentDatatableFilterFormMeta.cardHolderNumber = {
  name: 'cardHolderNumber',
  type: 'text',
  label: 'Numero porteur',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
PreControlTreatmentDatatableFilterFormMeta.processingStartDate = {
  name: "processingStartDate",
  type: "date",
  label: "Date Du",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
PreControlTreatmentDatatableFilterFormMeta.processingEndDate = {
  name: "processingEndDate",
  type: "date",
  label: "Au",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};
PreControlTreatmentDatatableFilterFormMeta.reasonCode = {
  name: "reasonCode",
  type: "select",
  label: "Code motif",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};



PreControlTreatmentDatatableFilterFormMeta.schema = yup.object().shape(getValidationSchema(PreControlTreatmentDatatableFilterFormMeta));

export default PreControlTreatmentDatatableFilterFormMeta;